import { Injectable } from "@angular/core";
import moment from "moment";
import { ApplicationService } from "../../../../services/application.service";
import { AuthService } from "../../../../services/auth.service";
import { MyUtils } from "../../../../services/my-utils.service";
import { Adapter } from "../../../records/classes/adapter";
import { RecoveryPlan } from "./recovery-plan";
import { RecoveryPlanDomain } from "./recovery-plan-domain";
import { RecoveryPlanStatus } from "./recovery-plan-status";

@Injectable({ providedIn: "root" })
export class DataMiningAdapter extends Adapter<RecoveryPlan, any> {
  constructor(
    private utils: MyUtils,
    private authService: AuthService,
    private applicationService: ApplicationService
  ) {
    super();
  }
  
  toView(plan: any) {
    return new RecoveryPlan(plan);
  }

  generateCreateBody(
    surveyId: string,
    brandId: string,
    surveyDate: string,
    formValue: any
  ) {
    let plan = {
      // additionalInformation: formValue.additionalInformation,
      contactReasonL1: formValue.contactReason.categoryLevel1,
      contactReasonL2: formValue.contactReason.categoryLevel2,
      dissatisfacionReason1Level1: formValue.dissatisfactionReason1.categoryLevel1,
      dissatisfacionReason1Level2: formValue.dissatisfactionReason1.categoryLevel2,
      dissatisfacionReason2Level1: formValue.dissatisfactionReason2.categoryLevel1,
      dissatisfacionReason2Level2: formValue.dissatisfactionReason2.categoryLevel2,
      personEnteringInfo: formValue.personEnteringInfo,
      surveyRequestId: surveyId,
      brandId: brandId,
      sectionValue: this.applicationService.navBarSelectValue.idItem,
      title: formValue.title,
      description: formValue.description,
      usrInsert: this.authService.email,
      status: RecoveryPlanStatus.OPEN,
      dtStart: this.parseDate(formValue.dateStart),
      dtEnd: this.parseDate(formValue.dateEnd),
      completedDate: this.utils.formatDateForService(surveyDate),
      assignTo: "",
      dealerId: null,
      dtApproved: null,
      dtCancel: null,
      dtClose: null,
      dtInsert: null,
      marketId: null,
      note: null,
      outletId: null,
      recoveryPlanId: null,
      regionId: null,
      usrApproved: null,
      usrCancel: null,
      usrClose: null,
      wave: null,
    };

    return plan;
  }

  generateEditBody(
    recoveryPlanData: RecoveryPlan,
    formValue: any
  ): Partial<RecoveryPlanDomain> {
    let plan: Partial<RecoveryPlanDomain> = {
      contactReasonL1: formValue.contactReason.categoryLevel1,
      contactReasonL2: formValue.contactReason.categoryLevel2,
      dissatisfacionReason1Level1: formValue.dissatisfactionReason1.categoryLevel1,
      dissatisfacionReason1Level2: formValue.dissatisfactionReason1.categoryLevel2,
      dissatisfacionReason2Level1: formValue.dissatisfactionReason2.categoryLevel1,
      dissatisfacionReason2Level2: formValue.dissatisfactionReason2.categoryLevel2,
      personEnteringInfo: formValue.personEnteringInfo,
      recoveryPlanId: recoveryPlanData.recoveryPlanId,
      surveyRequestId: recoveryPlanData.surveyRequestId,
      brandId: recoveryPlanData.brandId,
      regionId: recoveryPlanData.regionId,
      marketId: recoveryPlanData.marketId,
      dealerId: recoveryPlanData.dealerId,
      outletId: recoveryPlanData.outletId,
      sectionValue: this.applicationService.navBarSelectValue.idItem,
      title: recoveryPlanData.title,
      description: formValue.description,
      dtInsert: recoveryPlanData.dtInsert,
      usrInsert: this.authService.email,
      status: recoveryPlanData.status,
      dtStart: recoveryPlanData.dtStart,
      dtEnd: parseInt(moment(formValue.dateEnd).format("X")),
      dtApproved: null,
      wave: recoveryPlanData.wave,
      dtCancel: recoveryPlanData.dtCancel,
      usrCancel: recoveryPlanData.usrCancel,
      dtClose: recoveryPlanData.dtClose,
      note: recoveryPlanData.note,
      customerName: recoveryPlanData.customerName,
      completedDate: recoveryPlanData.completedDate,
      additionalInformation: formValue.additionalInformation,
      //assignTo: recoveryPlanData.assignTo,
      firstName: null,
      lastName: null,
      usrApproved: null,
    };

    return plan;
  }

  generateDeleteBody(recoveryPlanData: RecoveryPlan) {
    let plan = {
      brandId: null,
      dealerId: null,
      description: null,
      dtApproved: null,
      dtCancel: null,
      dtClose: null,
      dtEnd: null,
      dtInsert: null,
      dtStart: null,
      marketId: null,
      note: null,
      outletId: null,
      regionId: null,
      surveyRequestId: null,
      title: null,
      usrApproved: null,
      usrClose: null,
      usrInsert: null,
      wave: null,
      sectionValue: this.applicationService.navBarSelectValue.idItem,
      recoveryPlanId: recoveryPlanData.recoveryPlanId,
      status: RecoveryPlanStatus.DELETE,
      usrCancel: this.authService.email,
    };

    return plan;
  }

  generateCloseBody(
    recoveryPlanData: RecoveryPlan,
    formData: { comment: string }
  ) {
    let plan = {
      brandId: null,
      dealerId: null,
      description: null,
      dtApproved: null,
      dtCancel: null,
      dtClose: null,
      dtEnd: null,
      dtInsert: null,
      dtStart: null,
      marketId: null,
      outletId: null,
      regionId: null,
      sectionValue: this.applicationService.navBarSelectValue.idItem,
      surveyRequestId: null,
      title: null,
      usrApproved: null,
      usrCancel: null,
      usrInsert: null,
      wave: null,
      recoveryPlanId: recoveryPlanData.recoveryPlanId,
      status: RecoveryPlanStatus.CLOSE,
      usrClose: this.authService.email,
      note: formData.comment,
    };

    return plan;
  }

  private parseDate(date: moment.Moment | Date) {
    if (!moment.isMoment(date)) {
      date = moment(date);
    }
    let stringDate = date.toISOString();
    return stringDate;
  }
}
